import React from 'react';
import { CommentOutlined } from '@ant-design/icons';

import { notEmpty } from 'utils/ramdaAdditions';

export const PersonMessengers = ({ messengers }) => notEmpty(messengers) ? (
    <dl className="dl-horizontal">
        { messengers.map((messenger, index) => (
            <dd key={index}>
                <CommentOutlined /> {messenger.im} ({messenger.type})
            </dd>
        ))}
    </dl>
) : null;
